import languageModel from '../../models/language.model';
import 'CssFolder/components/pagination.scss';

export default function paginationComponent() {
  const DEFAULT_PAGE_SIZE = 10;
  const DEFAULT_CURRENT_PAGE = 1;

  var pageSize = 10;
  var totalItems = 0;
  var currentPage = 1;
  var pageSizeChoise = [10, 25, 50, 100, 200, 300];
  var maxSize = 5;
  var totalPages = currentPage;
  var pagers = [];
  var showBeginEnd = false;
  var footerNeed = true;
  let showPageSize = true;
  var onPageChanged = (e) => { };
  var onPageSizeChanged = (e) => { };

  const footerLabel = () => {
    if (totalItems == 0) {
      return "";
    }

    const first = ((currentPage - 1) * pageSize) + 1;
    const last = Math.min(currentPage * pageSize, totalItems);
    const total = totalItems;

    let labelString = languageModel.getText('LT00000007', 'Showing ${$.A} to ${$.B} of ${$.C} entries');
    labelString = labelString.replace('${$.A}', first)
    labelString = labelString.replace('${$.B}', last)
    labelString = labelString.replace('${$.C}', total)

    return labelString;
  };

  let _onPageSizeChanged = (e) => {
    pageSize = parseInt(e.target.value);
    currentPage = 1;
    onPageSizeChanged(currentPage, pageSize);
    _process();
    _generatePage();
  };

  let _canNext = () => {
    return currentPage < totalPages;
  }

  let _canPrevious = () => {
    return currentPage > 1;
  }

  let _onNext = (e, isend) => {
    e.preventDefault();
    if (_canNext()) {
      if (isend) {
        currentPage = totalPages;
      } else {
        currentPage++;
      }
      onPageChanged(currentPage);
      _generatePage();
    }
  }

  let _onPrevious = (e, isbegin) => {
    e.preventDefault();
    if (_canPrevious()) {
      if (isbegin) {
        currentPage = 1;
      } else {
        currentPage--;
      }
      onPageChanged(currentPage);
      _generatePage();
    }
  }

  let _onIndex = (e, index) => {
    e.preventDefault();
    currentPage = index;
    onPageChanged(currentPage);
    _generatePage();
  }

  let _getClass = (o) => {
    let css = "";
    for (var k in o) {
      if (o[k]) {
        css = `${css} ${k}`;
      }
    }
    return css;
  }
  let _generatePage = () => {
    let startPage = 1;
    let endPage = totalPages;
    if (totalPages > 0) {

      startPage = Math.max(currentPage - Math.floor(maxSize / 2), 1);
      endPage = startPage + maxSize - 1;

      if (endPage > totalPages) {
        endPage = totalPages;
        startPage = Math.max(endPage - maxSize + 1, 1);
      }
    }
    pagers = [];
    for (let i = startPage; i <= endPage; i++) {
      pagers.push(i);
    }

  }
  let _process = () => {
    totalPages = Math.floor(totalItems / pageSize);
    if (totalItems % pageSize != 0) {
      totalPages++;
    }
    _generatePage();
  }

  let init = (vnode) => {
    if (vnode.attrs.onPageChanged) {
      onPageChanged = vnode.attrs.onPageChanged;
    }
    if (vnode.attrs.showPageSize == undefined){
      showPageSize = true;
    } else {
      showPageSize = vnode.attrs.showPageSize
    }
   
    if (vnode.attrs.onPageSizeChanged) {
      onPageSizeChanged = vnode.attrs.onPageSizeChanged;
    }
    if (vnode.attrs.footerNeed == undefined || vnode.attrs.footerNeed) {

      footerNeed = true;
    } else {
      footerNeed = vnode.attrs.footerNeed
    }

    if (vnode.attrs.pageSizeChoise && Array.isArray(vnode.attrs.pageSizeChoise)) {
      pageSizeChoise = vnode.attrs.pageSizeChoise;
      if (pageSizeChoise.length > 0) {
        pageSize = pageSizeChoise[0];
      }
    }

    if (vnode.attrs.pageSize != null && !isNaN(vnode.attrs.pageSize)) {
      pageSize = parseInt(vnode.attrs.pageSize);
      if (pageSize === 0) {
        pageSize = DEFAULT_PAGE_SIZE;
      }

      if (pageSizeChoise.indexOf(pageSize) == -1) {
        pageSizeChoise.push(pageSize);
      }
    }
    if (vnode.attrs.totalItems != null && !isNaN(vnode.attrs.totalItems)) {
      totalItems = parseInt(vnode.attrs.totalItems);

    }
    if (vnode.attrs.currentPage != null && !isNaN(vnode.attrs.currentPage)) {
      currentPage = parseInt(vnode.attrs.currentPage);
      if (currentPage === 0) {
        currentPage = DEFAULT_CURRENT_PAGE;
      }
    }
    if (vnode.attrs.maxSize != null && !isNaN(vnode.attrs.maxSize)) {
      maxSize = parseInt(vnode.attrs.maxSize);
    }
    if (vnode.attrs.showBeginEnd) {
      showBeginEnd = vnode.attrs.showBeginEnd;
    }

    _process();
  }

  return {
    view: (vnode) => {
      init(vnode);
      return m(".hstack.justify-content-between.flex-wrap",
      showPageSize && m(".dataTables_length.order-sm-1",
          m("label",
            m("select.form-select.form-select-sm.form-select-solid", { onchange: _onPageSizeChanged },
              pageSizeChoise.map((item) => m("option", { "value": item, "selected": (item == pageSize ? 'selected' : null) }, item))
            )
          )
        ),
        m(".dataTables_paginate.paging_simple_numbers.order-sm-3",
          m("ul.pagination.mb-0",
            [
              showBeginEnd ? m("li", {
                "class": _getClass({ "paginate_button page-item previous": true, "disabled": !_canPrevious() })
              },
                m("a", {
                  "class": "page-link no-width", onclick: (e) => { _onPrevious(e, true) }
                },
                  m("i", { "class": "bi bi-chevron-double-left" })
                )
              ) : null,
              m("li", {
                "class": _getClass({ "paginate_button page-item previous": true, "disabled": !_canPrevious() })
              },
                m("a", {
                  "class": _getClass({ "page-link": true, "no-width": showBeginEnd }), onclick: (e) => { _onPrevious(e) }
                },
                  m("i", { "class": "bi bi-chevron-left" })
                )
              ),
              pagers.map((item) => m("li", {
                "class": _getClass({ "paginate_button page-item": true, "active": currentPage == item })
              },
                m("a", { "class": "page-link", onclick: (e) => { _onIndex(e, item) } }, item)
              )),
              ,
              m("li", {
                "class": _getClass({ "paginate_button page-item next": true, "disabled": !_canNext() })
              },
                m("a", {
                  "class": _getClass({ "page-link": true, "no-width": showBeginEnd }), onclick: (e) => { _onNext(e) }
                },
                  m("i", { "class": "bi bi-chevron-right" })
                )
              ),
              showBeginEnd ? m("li", {
                "class": _getClass({ "paginate_button page-item next": true, "disabled": !_canNext() })
              },
                m("a", {
                  "class": "page-link no-width", onclick: (e) => { _onNext(e, true) }
                },
                  m("i", { "class": "bi bi-chevron-double-right" })
                )
              ) : null
            ]
          )
        ),
        m("span.order-sm-2.flex-shrink.flex-fill.text-center", footerNeed && footerLabel())
      );
    }
  }
}
